import React, { useState, useEffect } from 'react';
import { Table, Row, Col, Breadcrumb, Typography } from 'antd';
import { intialPaginationState, unexpectedError, showingPageTotalRange, filter, dateTime } from '../../common_functions';

const NegHistory = props => {
  const [objects, setObjects] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
    //default filter
    let filter = {
      approved: {
        _eq: true,
      },
    };
    await getObjectsData(pagination, filter);
  })();
  }, []);
  const getObjectsData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('negative_req', {
        fields: [
          'id,alt_object_title,previous_alt_object_title,approved,action,negative.obj_name,print.object_name,negative.c_object,print.c_print,user_updated.first_name,user_updated.last_name,date_updated',
        ],
        filters: filters,
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setObjects(response.data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: ' Negative ID',
      dataIndex: 'negative',
      key: 'negative.c_object.id',
      sorter: true,
      ...filter('negative.c_object.id'),
      render: (text, record) => {
        return <>{!!record.negative ? record.negative.c_object : ''}</>;
      },
    },
    {
      title: 'Negative',
      dataIndex: 'negative.obj_name',
      key: 'negative.obj_name',
      sorter: true,
      ...filter('negative.obj_name'),
      render: (text, record) => {
        return <>{!!record.negative ? record.negative.obj_name : ''}</>;
      },
    },
    {
      title: 'Old Alt Object Title',
      dataIndex: 'previous_alt_object_title',
      key: 'previous_alt_object_title',
      sorter: true,
      ...filter('previous_alt_object_title'),
    },
    {
      title: 'New Alt Object Title',
      dataIndex: 'alt_object_title',
      key: 'alt_object_title',
      sorter: true,
      ...filter('alt_object_title'),
      render: (text, record) => {
        return <>{!!record.alt_object_title ? record.alt_object_title : ''}</>;
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'user_updated',
      key: 'user_updated',
      render: userName => {
        return <>{userName ? `${userName.first_name || ''} ${userName.last_name || ''}`.trim() : ''}</>;
      },
    },

    {
      title: 'Updated At',
      dataIndex: 'date_updated',
      key: 'date_updated',
      render: date_updated => {
        return <>{dateTime(date_updated)}</>;
      },
    },
  ];

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);

    let filtersitems = { approved: { _eq: true } };

    let filterMapping = {
      'negative.c_object.id': val => ({ negative: { c_object: { id: { _eq: val } } } }),
      'negative.obj_name': val => ({ negative: { obj_name: { _icontains: val } } }),
    };

    let filterConditions = Object.entries(filters).reduce((acc, [key, val]) => {
      if (val?.length) {
        let filterCondition = filterMapping[key] ? filterMapping[key](val[0]) : { [key]: { _icontains: val[0] } };
        acc.push(filterCondition);
      }
      return acc;
    }, []);

    if (filterConditions.length) {
      filtersitems['_and'] = filterConditions;
    }

    await getObjectsData(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Negatives", href: "/negatives/negative-history" }, { title: "Negative History" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Negative History
              </Typography.Title>
            </Col>
          </Row>
          <hr />
          <div className="users-list">
            {
              <Table
                className="no-fixed-last-col"
                rowKey="id"
                scroll={{ x: 'max-content' }}
                columns={columns}
                bordered
                dataSource={objects}
                pagination={{ ...pagination, ...showingPageTotalRange }}
                loading={loading}
                onChange={handleTableChange}
              />
            }
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default NegHistory;
